import type { auditReports } from '@mi-front/api-clients';
import { useForm, UseFormReturn } from 'react-hook-form';
import type { ReportDefinition } from '../../types';

export interface UseReportDefinitionFormResult {
  form: UseFormReturn<ReportDefinition>;
}

export function useReportDefinitionForm(
  definition: auditReports.GetReportDefinitionByReportTypeQueryResponse,
): UseReportDefinitionFormResult {
  const form = useForm<ReportDefinition>({
    defaultValues: {
      name: definition.name,
      isDefault: definition.isDefault,
      data: definition.definition,
    } as Partial<ReportDefinition>,
    mode: 'onChange',
  });

  return { form };
}
